import { apiClient, buildQueryString } from '@/services/utils';

export default {
  getAll(capsuleId, params) {
    const queryString = buildQueryString(params, false)

    return apiClient.get(`/capsules/${capsuleId}/layer_products${queryString}`);
  },

  create(capsuleId, layerId, productId, productUrl) {
    const params = {
      layer_product: {
        layer_id: layerId,
        product_id: productId,
        product_url: productUrl
      }
    }

    return apiClient.post(`/capsules/${capsuleId}/layer_products`, params)
  },

  update(capsuleId, layerProductId, externalUrl) {
    const params = { layer_product: { external_url: externalUrl } }

    return apiClient.patch(`/capsules/${capsuleId}/layer_products/${layerProductId}`, params)
  },

  destroy(capsuleId, layerProductId) {
    return apiClient.delete(`/capsules/${capsuleId}/layer_products/${layerProductId}`);
  }
}



// WEBPACK FOOTER //
// ./src/services/api/CapsuleLayerProductService.js